import { SET_PRND, CLEAR_PRND } from "../actions/prndActions";

const initialState = {
  prnd: []
}

function prndReducer(state = initialState, action) {
  switch (action.type) {
  case SET_PRND:
    return {
      ...state,
      prnd: action.payload
    }
  case CLEAR_PRND:
    return {
      ...state,
      prnd: []
    }
  default:
    return state;
  }
}

export default prndReducer;